export default "public/Language.png";